import script from "./BorrowAmount.vue?vue&type=script&setup=true&lang=ts"
export * from "./BorrowAmount.vue?vue&type=script&setup=true&lang=ts"

import "./BorrowAmount.vue?vue&type=style&index=0&id=7bdf7a42&lang=scss&scoped=true"

import exportComponent from "D:\\a\\1\\s\\src\\ApplicantPortal.Web\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7bdf7a42"]])

export default __exports__